// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/ItzBio65.png";
import thumb1 from "../assets/images/All-Products/ITZBIO-65.png";
import thumb2 from "../assets/images/All-Products/ItzBio65.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>ItzBio SB-65mg </h2>
              <p className="sub-heading text-muted">Advanced Antifungal Innovation for Endemic and Opportunistic Fungal Infections</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>With the advent of multiple variants of fungus & constant development of microbial resistance against various antifungal medications, effective oral antifungal is the need of the hour.</li>
                  <li>Recent studies with oral Itraconazole have shown effective results against various dermatophytosis.</li>
                  <li>We are introducing a novel formulation of SUBA (Superior bioavailable) itraconazole that utilizes a unique spray-drying/double drying technology producing a microencapsulated form of nanoparticles of itraconazole dispersed in a polymer matrix instead of the conventional crystalline form to enhance the solubility & bioavailability of the poorly soluble oral medication.</li>
                </ul>


              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">ItzBio SB-65mg ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "recommended", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "recommended"
                      ? "RECOMMENDED FOR"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li><strong>Enhanced solubility & absorption:</strong> Enhances the solubility and absorption of poorly soluble drugs such as conventional itraconazole.</li>
                    <li><strong>Intestinal absorption:</strong> Soluble in the higher pH of the small intestine, resulting in improved absorption.</li>
                    <li><strong>2X Bioavailability:</strong> Delivers approx. double the bioavailability of conventional 100 mg itraconazole capsules in a smaller 65 mg dose.</li>
                    <li><strong>Inter-patient variability:</strong> Shows less patient variability than conventional itraconazole thereby more safety & efficacy.</li>
                    <li><strong>Gastrointestinal Events:</strong> Less gastrointestinal events with SUBA itraconazole than conventional itraconazole group.</li>
                    <li><strong>Therapeutic levels:</strong> Therapeutic levels are achieved and maintained in both fed and fasted conditions.</li>
                  </ul>

                </div>
              )}
              {activeTab === "recommended" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                     <li>Chronic recalcitrant endemic & systemic dermatophytosis (yeast & moulds)</li> 
                      <li>Blastomycosis</li>
                      <li>Aspergillosis</li>
                      <li>Histoplasmosis</li>
                      <li>Candidiasis</li>
                      <li>Onychomycosis</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <strong>Itraconazole:</strong> Itraconazole is a broad-spectrum orally active triazole antifungal used for both prophylaxis and treatment of systemic fungal infections.
                    Itraconazole treats fungal infections by inhibiting the fungal cytochrome P450-dependent enzyme lanosterol 14α-demethylase, which is essential for ergosterol synthesis, a key component of the fungal cell membrane.
                    This disruption leads to membrane instability, increased permeability, and fungal cell death. It has a broad-spectrum antifungal activity against dermatophytes, yeasts and molds.

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
